import { type FC } from 'react';
import {
  Star
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconStarSimpleProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconStar: FC<UiIconStarSimpleProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Star}
      {...props}
    />
  );
};
